module.exports = __webpack_public_path__ + "static/img/jiaoshi.833181a8.png";